import { Context, type Effect } from "effect";
import type { StationClientFailure, StationSnapshot, StationWrite, StationWritten, WorkspaceSnapshot, WorkspaceWrite, WorkspaceWritten } from "./model.ts";

export interface StationApiShape {
  readonly station: (stationId: string) => Effect.Effect<StationSnapshot, StationClientFailure>;
  readonly updateStation: (stationId: string, payload: StationWrite) => Effect.Effect<StationWritten, StationClientFailure>;
  readonly workspace: (workspaceId: string, stationHint?: string) => Effect.Effect<WorkspaceSnapshot, StationClientFailure>;
  readonly updateWorkspace: (workspaceId: string, payload: WorkspaceWrite, stationHint?: string) => Effect.Effect<WorkspaceWritten, StationClientFailure>;
}
export class StationApi extends Context.Service<StationApi, StationApiShape>()("workerstation/frontend/StationApi") {}
